import { IconPlus, IconShieldCheck } from '@maia/icons';
import { Button, PageHeader } from '@maia/ui';
import { createFileRoute, Link } from '@tanstack/react-router';
import { getInsurancesOptions } from '../../../features/insurance/insurances/queryOptions';
import { InsuranceTable } from '../../../features/insurance/insurances/table';
import { mapInitialFilters } from '../../../utils/filter/utils';
import { validateSearch } from '../../../utils/pagination';
import { getProductFilterOptions } from '../../../features/insurance/productFilterOptions/queryOptions';

export const Route = createFileRoute('/_authenticated/insurances/')({
  component: Page,
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient }, deps: search }) => {
    const searchWithDefaultFilters = search.filter ? search : { ...search };

    const productFilterOptions = await queryClient.ensureQueryData(
      getProductFilterOptions(),
    );

    const insurances = await queryClient.ensureQueryData(
      getInsurancesOptions(mapInitialFilters(searchWithDefaultFilters)),
    );

    return { insurances, productFilterOptions };
  },
  validateSearch: validateSearch,
});

export function Page() {
  const { insurances, productFilterOptions } = Route.useLoaderData();

  return (
    <div className="layout-simple">
      <PageHeader
        className="area-page-header"
        icon={IconShieldCheck}
        title="Verzekeringen"
        actions={
          <Link to="/add-insurance">
            <Button intent="cta" size="default" iconLeft={IconPlus}>
              Nieuwe verzekering
            </Button>
          </Link>
        }
      />
      <div className="area-page-content content-grid">
        <div className="col-span-full flex items-center justify-between">
          <InsuranceTable
            insurances={insurances}
            productFilterOptions={productFilterOptions.products}
          />
        </div>
      </div>
    </div>
  );
}
